import { cn } from "@babybjorn/ui";
import type { FC, PropsWithChildren } from "react";
import Button from "../../../Button";
import * as s from "./MenuList.module.scss";

type Props = PropsWithChildren<{
	title?: string;
	showAllLabel?: string;
	showAllHref?: string;
	isSubMenuList?: boolean;
}>;

const MenuList: FC<Props> = ({
	children,
	title,
	showAllLabel,
	showAllHref,
	isSubMenuList = false,
}) => {
	return (
		<div className={s.container}>
			{title && <h4>{title}</h4>}
			<div className={cn({ [s.border]: isSubMenuList })}>
				<ul
					className={cn(s.menuList, {
						[s.subMenuList]: isSubMenuList,
						[s.notSubMenu]: !isSubMenuList,
					})}
				>
					{children}
				</ul>
				{showAllHref && (
					<Button
						variant="noBg"
						label={showAllLabel}
						icon="arrow-right"
						className={s.showAllButton}
						href={showAllHref}
						noPaddingInline
					/>
				)}
			</div>
		</div>
	);
};
export default MenuList;
